(function HotelEngineSearchForm($, Adzuki)
{
	'use strict';

	const component = {
		emits : ['search-start', 'send-results', 'form-data', 'coordinates-update'],
		inject: {
			openAlert: {
				default: () => undefined
			},
			openToast: {
				default: () => undefined
			}
		},
		props: {
			initialFormData: {
				type   : Object,
				default: null
			},
			initialCoordinates: {
				type   : Object,
				default: () => ({})
			}
		},
		template: '#he-search-form',
		data() {
			return {
				baseUri    : Adzuki.base_uri,
				coordinates: {},
				formData   : {
					locationSearch: '',
					locationRadius: 20,
					checkIn       : '',
					checkOut      : '',
					numRooms      : 1,
					rooms         : []
				},
				radiusOptions: [
					{
						value: '5',
						label: '5 miles'
					},
					{
						value: '10',
						label: '10 miles'
					},
					{
						value: '20',
						label: '20 miles'
					},
					{
						value: '50',
						label: '50 miles'
					},
					{
						value: '100',
						label: '100 miles'
					}
				],
				searchCriteria  : {},
				suggestions     : [],
				showSuggestions : false,
				showMoreOptions : false,
				hotels          : [],
				showRoomModal   : false,
				roomModalProps  : {},
				roomComponent   : null,
				isLoading       : false,
				skipCheckoutSync: false,
				_prevCheckIn    : '',
			};
		},
		computed: {
			todaysDate() {
				return new Date().toISOString().split('T')[0];
			},
			numberTravelers() {
				let totalAdults = 0;
				let totalChildren = 0;

				this.formData.rooms.forEach(room => {
					totalAdults += parseInt(room.numAdults) || 0;
					totalChildren += parseInt(room.numChildren) || 0;
				});

				return {
					totalGuests: totalAdults + totalChildren,
					adults     : totalAdults,
					children   : totalChildren,
				};
			},
			minCheckOutDate() {
				if (!this.formData.checkIn) {
					return this.todaysDate;
				}

				let d = new Date(this.formData.checkIn + 'T12:00:00'); // avoid UTC shift

				if (isNaN(d.getTime())) {
					const parsed = moment(this.formData.checkIn, ['YYYY-MM-DD', 'MM/DD/YYYY', 'M/D/YYYY'], true);

					if (parsed.isValid()) {
						d = parsed.toDate();
					} else {
						return this.todaysDate;
					}
				}

				d.setDate(d.getDate() + 1);
				return this.formatLocalDate(d);
			},
			maxCheckOutDate() {
				const checkInDate = this.parseLocalDate(this.formData.checkIn);

				if (!checkInDate) {
					return '';
				}

				const maxDate = new Date(checkInDate);
				maxDate.setDate(maxDate.getDate() + 30);

				return this.formatLocalDate(maxDate);
			},
		},
		methods: {
			parseLocalDate(dateStr) {
				if (!dateStr || typeof dateStr !== 'string') {
					return null;
				}

				const parsedDate = new Date(`${dateStr}T12:00:00`);

				return Number.isNaN(parsedDate.getTime()) ? null : parsedDate;
			},
			formatLocalDate(date) {
				const y = date.getFullYear();
				const m = String(date.getMonth() + 1).padStart(2, '0');
				const d = String(date.getDate()).padStart(2, '0');

				return `${y}-${m}-${d}`;
			},
			getStayNights(checkInDate, checkOutDate) {
				return Math.round((checkOutDate - checkInDate) / (1000 * 60 * 60 * 24));
			},
			isStayWithinMaxDays(checkIn, checkOut) {
				const checkInDate  = this.parseLocalDate(checkIn);
				const checkOutDate = this.parseLocalDate(checkOut);

				if (!checkInDate || !checkOutDate) {
					return true;
				}

				return this.getStayNights(checkInDate, checkOutDate) <= 30;
			},
			clampCheckoutToMaxStay() {
				const checkInDate  = this.parseLocalDate(this.formData.checkIn);
				const checkOutDate = this.parseLocalDate(this.formData.checkOut);

				if (!checkInDate || !checkOutDate) {
					return false;
				}

				if (this.getStayNights(checkInDate, checkOutDate) <= 30) {
					return false;
				}

				const clamped = new Date(checkInDate);
				clamped.setDate(clamped.getDate() + 30);
				this.formData.checkOut = this.formatLocalDate(clamped);

				return true;
			},
			syncCheckoutFromCheckIn({ force = false, preserveNights = false } = {}) {
				if (this.skipCheckoutSync) {
					return;
				}

				const checkInDate = this.parseLocalDate(this.formData.checkIn);

				if (!checkInDate) {
					return;
				}

				const existingCheckOut = this.parseLocalDate(this.formData.checkOut);

				if (preserveNights) {
					const prevCheckIn = this.parseLocalDate(this._prevCheckIn);
					let nights        = 1;

					if (prevCheckIn && existingCheckOut && existingCheckOut > prevCheckIn) {
						nights = Math.round((existingCheckOut - prevCheckIn) / (1000 * 60 * 60 * 24));
					}

					if (nights > 30) {
						nights = 30;
					}

					const checkOutDate = new Date(checkInDate);
					checkOutDate.setDate(checkOutDate.getDate() + nights);
					this.formData.checkOut = this.formatLocalDate(checkOutDate);
					this._prevCheckIn       = this.formData.checkIn;

					return;
				}

				if (!force && existingCheckOut && existingCheckOut > checkInDate) {
					this.clampCheckoutToMaxStay();
					this._prevCheckIn = this.formData.checkIn;

					return;
				}

				const checkOutDate = new Date(checkInDate);
				checkOutDate.setDate(checkOutDate.getDate() + 1);
				this.formData.checkOut = this.formatLocalDate(checkOutDate);
				this._prevCheckIn       = this.formData.checkIn;
			},
			onCheckInManualChange() {
				this.syncCheckoutFromCheckIn({ preserveNights: true });
			},
			onCheckOutManualChange() {
				this.clampCheckoutToMaxStay();
			},
			applyFormDataFromSource(sourceFormData) {
				if (!sourceFormData || typeof sourceFormData !== 'object') {
					return;
				}

				this.skipCheckoutSync = true;

				this.formData = {
					locationSearch: sourceFormData.locationSearch || '',
					locationRadius: sourceFormData.locationRadius || 20,
					checkIn       : sourceFormData.checkIn || '',
					checkOut      : sourceFormData.checkOut || '',
					numRooms      : sourceFormData.numRooms || 1,
					rooms         : Array.isArray(sourceFormData.rooms) ? JSON.parse(JSON.stringify(sourceFormData.rooms)) : []
				};

				if (this.formData.rooms.length === 0) {
					for (let i = 0; i < this.formData.numRooms; i++) {
						this.formData.rooms.push({
							roomNumber  : i + 1,
							numAdults   : 2,
							numChildren : 0,
							childrenAges: []
						});
					}
				}

				this._prevCheckIn       = this.formData.checkIn;
				this.skipCheckoutSync = false;
			},
			isOnSearchResultsPage() {
				return Boolean(document.getElementById('he-search-results'));
			},
			clearData() {
				sessionStorage.removeItem('formData');
				sessionStorage.removeItem('coordinates');
				sessionStorage.removeItem('searchCriteria');
				sessionStorage.removeItem('locationSearch');
				sessionStorage.removeItem('searchLocation');
				sessionStorage.removeItem('searchFilters');
				sessionStorage.removeItem('searchSort');
				sessionStorage.removeItem('giataId');
				sessionStorage.removeItem('selectedHotel');
				sessionStorage.removeItem('selectedRoom');
				sessionStorage.removeItem('rate_select_string');

				this.$hotelDb.deleteDB();

				this.formData = {
					locationSearch: '',
					locationRadius: 20,
					checkIn       : '',
					checkOut      : '',
					numRooms      : 1,
					rooms         : [],
				};
				this.coordinates = {};

				this.formData.rooms = Array.from({length: this.formData.numRooms}, (_, index) => ({
					roomNumber  : index + 1,
					numAdults   : 2,
					numChildren : 0,
					childrenAges: []
				}));

				this.showSearch = true;
			},
			clearLocationField() {
				this.formData.locationSearch = '';
				this.suggestions = [];
				this.showSuggestions = false;
				this.coordinates = {};
			},
			toggleMoreOptions() {
				this.showMoreOptions = !this.showMoreOptions;
			},
			hideSuggestionsAfterDelay() {
				// Add a small delay before hiding suggestions, to allow selection via clicks
				setTimeout(() => {
					this.showSuggestions = false;
				}, 500);
			},
			async searchLocations() {
				const searchQuery = this.formData.locationSearch.trim();
				if (searchQuery.length === 0) {
					this.suggestions     = [];
					this.showSuggestions = false;
					return;
				}

				try {
					const formData = new FormData();
					formData.append('type', 'locationSearchBroader');
					formData.append('term', searchQuery);

					// Make a POST request to the backend
					const response = await fetch(this.baseUri + '/Searches/google', {
						method: 'POST',
						body  : formData,
					});

					// Handle errors if any
					if (!response.ok) {
						throw new Error(`Error while fetching suggestions: ${response.statusText}`);
					}

					// Parse the response JSON
					const data = await response.json();

					if (data.results) {
						this.suggestions     = data.results;
						this.showSuggestions = true;
					} else {
						console.error('Unexpected data format from server:', data);
						this.suggestions = [];
					}
				} catch (err) {
					console.error('Error in searchLocations:', err.message);
					this.suggestions = [];
				}
			},
			buildLocationPayload() {
				const location = {
					radius: this.formData.locationRadius
				};

				if (
					this.coordinates.lat !== undefined
					&& this.coordinates.lat !== null
					&& this.coordinates.lng !== undefined
					&& this.coordinates.lng !== null
				) {
					location.lat = this.coordinates.lat;
					location.lng = this.coordinates.lng;
				}

				if (this.coordinates.place_id) {
					location.place_id = this.coordinates.place_id;
				}

				return location;
			},
			async submitForm(options = {}) {
				const preserveFilters = options.preserveFilters === true;
				const location = this.buildLocationPayload();

				if (!location.place_id && (location.lat === undefined || location.lng === undefined)) {
					alert('Please select a location from the dropdown suggestions.');
					return;
				}

				if (!this.isStayWithinMaxDays(this.formData.checkIn, this.formData.checkOut)) {
					alert('You can’t book for more than 30 days. Please adjust your search to 30 days or less.');
					return;
				}

				if (!preserveFilters) {
					sessionStorage.removeItem('searchFilters');
					sessionStorage.removeItem('searchSort');
				}

				this.$emit('search-start', { preserveFilters });
				this.$emit('form-data', this.formData);
				this.$emit('coordinates-update', this.coordinates);

				this.isLoading = true;

				// If there is any data from the last search laying around lets clear that data.
				sessionStorage.removeItem('selectedHotel');
				sessionStorage.removeItem('selectedRoom');
				sessionStorage.removeItem('rate_select_string');

				sessionStorage.setItem('formData', JSON.stringify(this.formData));
				sessionStorage.setItem('coordinates', JSON.stringify(this.coordinates));
				sessionStorage.setItem('locationSearch', JSON.stringify(this.formData.locationSearch));

				try {
					const structuredRooms = this.formData.rooms.map((room) => ({
						num_adults  : room.numAdults.toString(),
						num_children: room.numChildren.toString(),
						child_ages  : room.childrenAges.map((age) => age.toString())
					}));

					const formData = new FormData();

					formData.append('check_in', this.formData.checkIn);
					formData.append('check_out', this.formData.checkOut);
					formData.append('rooms', JSON.stringify(structuredRooms));
					formData.append('location', JSON.stringify(location));

					const searchCriteria = {
						check_in : this.formData.checkIn,
						check_out: this.formData.checkOut,
						rooms    : structuredRooms
					};

					// Keep cache key behavior by combining both objects for IndexedDB lookup/storage
					const combinedSearchCriteria = {
						...searchCriteria,
						location: location
					};

					const searchKey = JSON.stringify(combinedSearchCriteria);

					// keep split copies for downstream behavior
					sessionStorage.setItem('searchCriteria', JSON.stringify(searchCriteria));
					sessionStorage.setItem('searchLocation', JSON.stringify(location));


					const response = await fetch(this.baseUri + '/HotelEngine/searchHotels', {
						method: 'POST',
						body  : formData,
					});

					if (!response.ok) {
						throw new Error(`Error fetching details: ${response.statusText}`);
					}

					let jsonResponse = await response.json();
					const hotels = Array.isArray(jsonResponse?.hotels) ? jsonResponse.hotels : [];

					this.hotels = hotels;
					this.$emit('send-results', hotels);

					try {
						await this.$hotelDb.storeHotels(searchKey, JSON.stringify(hotels));
					} catch (error) {
						console.error('Error storing hotels:', error);
					}

					this.isLoading = false;

					if (this.isOnSearchResultsPage()) {
						return;
					}

					this.$nextTick(() => {
						if (Adzuki.app === 'Web') {
							window.location.href = this.baseUri + '/HotelSearch/searchResults';
						} else {
							window.location.href = this.baseUri + '/HotelEngine/searchResults';
						}
					});

				} catch (error) {
					console.error('Error:', error);
					this.isLoading = false;
					alert('Error submitting form!');
				}
			},
			async selectSuggestion(suggestion) {
				if (!suggestion.place_id) {
					return;
				}

				this.formData.locationSearch = suggestion.name + ', ' + suggestion.vicinity;
				this.searchCriteria          = suggestion;
				this.suggestions             = [];
				this.showSuggestions         = false;

				// Always keep place_id so search still works if the coordinate lookup fails
				this.coordinates = {
					place_id: suggestion.place_id
				};

				try {
					const formData = new FormData();

					formData.append('type', 'coordinateData');
					formData.append('place_id', suggestion.place_id);

					const response = await fetch(this.baseUri + '/Searches/google', {
						method: 'POST',
						body  : formData,
					});

					if (!response.ok) {
						throw new Error(`Error fetching details: ${response.statusText}`);
					}

					const additionalData = await response.json();

					if (additionalData.results) {
						this.coordinates = {
							...additionalData.results,
							place_id: suggestion.place_id
						};
					}
				} catch (err) {
					console.error('Error fetching additional details:', err);
				}
			},
			handleRoomUpdate(updatedRooms) {
				this.formData.numRooms = updatedRooms.numRooms;
				this.formData.rooms    = updatedRooms.rooms;
				this.showRoomModal  = false;
			},
			openRoomConfig() {
				this.showRoomModal = true;
				this.roomModalProps = {
					rooms    : this.formData.rooms,
					fromModal: true
				};
				this.roomComponent = Vue.markRaw(Adzuki.VueComponents.HotelEngineRoomConfig);
			}
		},
		watch: {
			initialFormData: {
				immediate: true,
				deep     : true,
				handler(newFormData) {
					this.applyFormDataFromSource(newFormData);
				}
			},
			initialCoordinates: {
				immediate: true,
				deep     : true,
				handler(newCoordinates) {
					if (newCoordinates && Object.keys(newCoordinates).length > 0) {
						this.coordinates = newCoordinates;
					}
				}
			},
			'formData.numRooms': {
				handler(newNumRooms) {
					const currentCount = this.formData.rooms.length;
					const newCount = parseInt(newNumRooms) || 0;

					if (newCount > currentCount) {
						// Add new rooms
						for (let i = currentCount; i < newCount; i++) {
							this.formData.rooms.push({
								roomNumber  : i + 1,
								numAdults   : 2,
								numChildren : 0,
								childrenAges: []
							});
						}
					} else if (newCount < currentCount) {
						// Remove rooms
						this.formData.rooms = this.formData.rooms.slice(0, newCount);
					}
				}
			},
			'formData.checkIn': function watchCheckIn(newCheckIn, oldCheckIn) {
				if (!newCheckIn || newCheckIn === oldCheckIn) {
					return;
				}

				this.syncCheckoutFromCheckIn();
			}
		},
		mounted() {
			if (this.initialFormData) {
				this.applyFormDataFromSource(this.initialFormData);
			}

			if (this.initialCoordinates && Object.keys(this.initialCoordinates).length > 0) {
				this.coordinates = this.initialCoordinates;
			}
		}
	};

	Adzuki.VueComponents.HotelEngineSearchForm = component;
}(jQuery, window.Adzuki || {}));
